module.exports = __webpack_public_path__ + "img/close.523e963b.png";